import * as React from "react";
import { useState, useEffect } from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import Container from "@mui/material/Container";
import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { Link, useLocation, NavLink } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import { NewButton } from "./NewButton";


const NavButton = ({ name, link, onClick }) => {
   const [classes, setClasses] = useState('box');
   const [brightness, setBrightness] = useState('100%');

   return (
      <Link to={link} onClick={onClick}>
         <Button
            endIcon={
               <img alt='chevron-right' src={"./assets/media/chevron.png"} className={classes} />
            }
            onMouseEnter={() => { setClasses('box bounce-1'); setBrightness("90%") }}
            onMouseLeave={() => { setClasses('box'); setBrightness("100%") }}
            sx={{
               width: "125px",
               display: "flex",
               border: "1px solid white",
               height: "100%",
               borderRadius: "25px",
               backgroundColor: '#223B52 !important',
               webkitBoxShadow: " 9px 9px 5px -4px rgba(0,0,0,0.45)",
               mozBoxShadow: " 9px 9px 5px -4px rgba(0,0,0,0.45)",
               boxShadow: " 9px 9px 5px -4px rgba(0,0,0,0.45)",
               color: "white !important",
               fontWeight: "900",
               filter: `brightness(${brightness})`
            }}
         >
            {name}
         </Button>
      </Link>
   );
};


const pages = [

   { name: "overview", link: `/`, active: false },
   { name: "investors", link: "/#investor-section", active: false },
   { name: "agenda", link: `/agenda`, active: false },
   { name: "sponsors", link: `/sponsors`, active: false },
   // { name: "matchmaking", link: `/matchmaking`, active: false },
   // { name: "venue", link: `/venue`, active: false },
   // { name: "press", link: `/press-passes`, active: false },
];

const settings = ["Profile", "Account", "Dashboard", "Logout"];


export const NavBarFinal = () => {
   const [open, setOpen] = useState(false);
   const [anchorElUser, setAnchorElUser] = useState(null);


   const [showMenu, setShowMenu] = useState(false);

   useEffect(() => {
      const script = document.createElement('script');
      script.src = 'https://js.hsforms.net/forms/v2.js';
      document.body.appendChild(script);

      script.addEventListener('load', () => {
         if (window.hbspt) {
            window.hbspt.forms.create({
               portalId: '536350',
               formId: '5f67c12f-e4b9-4386-950a-ce96f986918f',
               target: '#preregisterForm'
            })
         }
      });
   }, [open]);

   // const handleOpenNavMenu = (event) => {
   //   setAnchorElNav(event.currentTarget);
   // };
   // const handleOpenUserMenu = (event) => {
   //   setAnchorElUser(event.currentTarget);
   // };



   const handleCloseUserMenu = () => {
      setAnchorElUser(null);
   };



   const handleClose = () => {
      setOpen(false);
   };

   //used in navlink buttons to change #investor-section link between a and link, and to change the link if in home
   let location = useLocation();
   // const isRoot = location.pathname === "/" || location.pathname === "/events/fvs22";


   const NavLinkButton = ({ page }) => {
      const [active, setActive] = useState(false)

      // if (page.link.includes("#investor-section")) {
      //    if (isRoot) {
      //       page.link = "#investor-section";
      //    } else {
      //       page.link = "#investor-section";
      //    }
      // }
      const showBorderBottom = active;
      // const showBorderBottom = window.location.href == page.link || window.location.href == `${page.link}/` || active || window.location.pathname.includes(page.name);
      return (
         page.link.includes("#investor-section") ?
            <HashLink to={page.link}>
               <Button
                  key={page.name}
                  onMouseEnter={e => setActive(true)}
                  onMouseLeave={e => setActive(false)}
                  sx={{
                     mr: 2,
                     borderBottom: "2px solid white",
                     borderBottomColor: !showBorderBottom && "rgba(0,0,0,0)",
                     color: 'white',
                     display: "block",
                     fontFamily: "Poppins, sans-serif !important",
                     borderRadius: "0px",
                  }}
               >
                  {page.name}
               </Button>
            </HashLink>
            :
            <NavLink to={page.link}>
               <Button
                  key={page.name}
                  onMouseEnter={e => setActive(true)}
                  onMouseLeave={e => setActive(false)}
                  className="fvs22-nav-button"
                  sx={{
                     mr: 2,
                     borderBottom: (active) && "2px solid white",
                     color: 'white',
                     display: "block",
                     fontFamily: "Poppins, sans-serif !important",
                     borderRadius: "0px",
                  }}
               >
                  {page.name}
               </Button>
            </NavLink>
      )
   }
   const NavLinkButtonMobile = ({ page }) => {
      // if (page.link.includes("#investor-section")) {
      //    if (isRoot) {
      //       page.link = "#investor-section";
      //    } else {
      //       page.link = "/events/fvs22#investor-section";
      //    }
      // }
      return (
         page.link.includes("#investor-section") ?
            <Link to={page.link}>
               <Typography
                  textAlign="left"
                  paddingLeft="35px"
                  lineHeight="2rem"
                  sx={{ fontFamily: "Poppins, sans-serif !important", color: "white", }}
               >
                  {page.name.toUpperCase()}
               </Typography>
            </Link> :
            <Link to={page.link}>
               <Typography
                  textAlign="left"
                  paddingLeft="35px"
                  lineHeight="2rem"
                  sx={{ fontFamily: "Poppins, sans-serif !important", color: "white", }}
               >
                  {page.name.toUpperCase()}
               </Typography>
            </Link>
      )
   }

   return (
      <>
         <AppBar
            position="sticky"
            sx={{
               height: '10% !important',
               backgroundImage: "linear-gradient(90deg, #000, #00C2FF)",
               backgroundColor: 'white',
               m: 0,
               width: "100%",
               p: .5,
               fontFamily: "Poppins, sans-serif !important",
            }}
         >
            <Container maxWidth="xl" sx={{ margin: "auto" }}>
               <Toolbar disableGutters={true}>
                  <Typography
                     variant="h6"
                     noWrap
                     component="div"
                     sx={{
                        mr: 2,
                        flex: 1,
                        fontFamily: "Poppins, sans-serif !important",
                        display: { xs: "none", md: "flex" },
                     }}
                  >
                     <div >
                        <a href="https://youngstartup.com/upcoming">
                           <img
                              alt='company-logo'
                              src="./assets/events/fvs22/Nav Bar Logo.png"
                              style={{ width: '100%', maxWidth: "350px", minWidth: "150px", }}
                           />
                        </a>
                        {/* <Stack>
                <div style={{display:'flex', height:'fit-content'}}>July 19-20</div>
                <div style={{display:'flex', height:'fit-content'}}>Hyatt Regency</div>
              </Stack> */}
                     </div>
                  </Typography>

                  <Box sx={{ flex: 1, flexGrow: 1, display: { xs: "flex", md: "none" } }}            >
                     <IconButton
                        size="large"
                        aria-label="account of current user"
                        aria-controls="menu-appbar"
                        aria-haspopup="true"
                        onClick={() => setShowMenu(!showMenu)}
                        color="inherit"
                     >
                        <MenuIcon />
                     </IconButton>
                  </Box>
                  <Typography
                     variant="h6"
                     noWrap
                     component="div"
                     sx={{
                        flexGrow: 1,
                        display: {
                           xs: "flex",
                           md: "none",
                           fontFamily: "Poppins, sans-serif !important",
                        },
                     }}
                  >
                     <div style={{ display: "flex", alignItems: "center", gap: '5%' }}>
                        <Link to="/events/fvs22">
                           <img
                              alt='company-logo'
                              src="./assets/events/fvs22/Nav Bar Logo.png"
                              style={{ objectFit: "scale-down", minWidth: "150px", maxWidth: "250px" }}
                           />
                        </Link>

                     </div>
                  </Typography>

                  <Box
                     sx={{
                        flex: 1,
                        ml: 0,
                        display: { xs: "none", md: "flex", justifyContent: "center" },
                     }}
                  >
                     {pages.map((page) => (
                        <NavLinkButton key={Math.random()} page={page} />
                     ))}
                  </Box>

                  <Box sx={{ flex: 1, display: window.innerWidth < 1000 ? "none" : "relative" }} >
                     <div style={{ display: "flex", justifyContent: "right", gap: "5%" }} >
                        {/* <NavButton name={"register"} link={'/events/fvs22/registration'} borderColor={"white"} />
                        <NavButton name={'present'} link={'/events/fvs22/top-innovators'} borderColor={"white"} /> */}
                     </div>
                     <Menu
                        sx={{ mt: "45px" }}
                        id="menu-appbar"
                        anchorEl={anchorElUser}
                        anchorOrigin={{
                           vertical: "top",
                           horizontal: "right",
                        }}
                        keepMounted
                        transformOrigin={{
                           vertical: "top",
                           horizontal: "right",
                        }}
                        open={Boolean(anchorElUser)}
                        onClose={handleCloseUserMenu}
                     >
                        {settings.map((setting) => (
                           <MenuItem key={setting} onClick={handleCloseUserMenu}>
                              <Typography textAlign="center">{setting}</Typography>
                           </MenuItem>
                        ))}
                     </Menu>
                  </Box>
               </Toolbar>
            </Container>

            {showMenu &&
               <div style={{
                  backgroundImage: "linear-gradient(90deg, #000, #00C2FF)",
                  width: "100%"
               }}>
                  <ul style={{ paddingTop: "1rem", paddingBottom: "1rem", marginBottom: "0" }}>
                     {pages.map((page) => (
                        <li
                           key={page.name}
                           onClick={() => setShowMenu(!showMenu)}
                        >
                           <NavLinkButtonMobile page={page} />
                        </li>
                     ))}
                  </ul>

                  <div
                     style={{
                        paddingLeft: "35px",
                        paddingBottom: "20px",
                        display: "flex",
                        alignContent: "space-around"
                     }}
                  >
                     {/* <NewButton name={"Register"} link={"/events/fvs22/registration"} color={"white"} bgColor={"#00C2FF"} onClick={() => setShowMenu(false)} /> */}
                     <br />
                     {/* <NewButton name={"Present"} link={`/events/fvs22/top-innovators`} color={"white"} bgColor={"#00C2FF"} onClick={() => setShowMenu(false)} /> */}
                  </div>
               </div>
            }
         </AppBar>

         <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
         >
            <DialogContent>
               <div id="preregisterForm"></div>
            </DialogContent>
         </Dialog>
      </>
   );
};
